"use client";

import { useState, useEffect } from "react";
import HeroSection from "../src/components/home/HeroSection";
import LearnerSection from "../src/components/home/LearnerSection";
// import MentorshipSection from "../src/components/home/MentorshipSection";
// import WorkshopSection from "../src/components/home/WorkshopSection";
// import AdvantageSection from "../src/components/home/AdvantageSection";
// import SuccessStories from "../src/components/home/SuccessStories";
// import CompaniesSection from "../src/components/home/CompaniesSection";
// import TestimonialsSection from "../src/components/home/TestimonialsSection";
// import Business from "../src/components/home/Business";
// import Investors from "../src/components/home/Investors";
// import investorsData from "../src/data/investors.json";
import Cards from "../src/components/home/Cards";
// import CommunitySection from "../src/components/home/CommunitySection";
// import communityData from "../src/data/communityData.json";
import workshopsData from "../src/data/workshops.json";
import programsDataJson from "../src/data/mentorship-programs.json";
import mentorsDataJson from "../src/data/mentors.json";
import Practice from "@/components/home/Practice";
import Value from "@/components/home/Value";
import AITraining from "@/components/home/AITraining";
import Frameworks from "@/components/home/Frameworks";
import Tools from "@/components/home/Tools";
import ToolsSection from "@/components/home/ToolsSection";
import VideoTestimonials from "@/components/home/VideoTestimonials";
import MentorSection from "@/components/home/MentorSection";
import AITransform from "@/components/home/AITransform";
import Testimonials from "@/components/home/Testimonials";
import FAQ from "@/components/home/FAQ";
import HomeSticky from "@/components/home/HomeSticky";

export default function Home() {
  const [programs, setPrograms] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
      try {
        setLoading(true);
      setPrograms(programsDataJson || []);
      setMentors(mentorsDataJson || []);
      setWorkshops(workshopsData || []);
      } catch (error) {
      console.error("Error loading local data:", error);
        setError(error.message);
        setPrograms([]);
        setMentors([]);
        setWorkshops([]);
      } finally {
        setLoading(false);
      }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#002726] mx-auto mb-4"></div>
          <p className="text-[#002726] text-lg">Loading content...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 text-lg mb-4">
            Error loading content: {error}
          </p>
          <button 
            onClick={() => window.location.reload()} 
            className="bg-[#002726] text-white px-4 py-2 rounded-lg hover:bg-[#004726] transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <main>
      <HeroSection />
      <LearnerSection />
      <Practice />
      <Value />
      <Testimonials />
      <AITraining />
      <Frameworks />
      <Tools />
      <ToolsSection />
      <VideoTestimonials />
      <MentorSection />
      <AITransform />
      <Cards />
      <FAQ />
      <HomeSticky />
      {/* <MentorshipSection programs={programs} mentors={mentors} /> */}
      {/* <WorkshopSection workshops={workshops} mentors={mentors} />
      <AdvantageSection />
      <SuccessStories />
      <CompaniesSection />
      <TestimonialsSection />
      <Business />
      <div>
        <CommunitySection communityData={communityData} />
      </div>
      <Investors investors={investorsData} /> */}
    </main>
  );
}
